angular.module("survey").directive("expressLaneButton", [expressLaneButton])

function expressLaneButton() {
  return {
    restrict: "E",
    controllerAs: "btn",
    template: `<button class="express-lane-button" ng-click="btn.click()">{{ btn.display }}</button>`,
    controller: ["$scope", "$element", function($scope, $element) {
      const btn = this;
      if (typeof $scope.amt === "number") {
        if ($scope.question.express_lane_amount_text) {
          btn.display = $scope.question.express_lane_amount_text.replace("[AMOUNT]", $scope.amt);
        } else {
          btn.display = "$" + $scope.amt;
        }
      } else {
        btn.display = $scope.question.express_lane_other_text || $scope.amt;
      }

      btn.click = function() {
        const question = $scope.question, survey = $scope.survey;
        if (survey.submitting) return;
        const prop = typeof $scope.amt === "number" ? "numeric_value" : "text";
        survey.responses[question.page - 1][question.id] = {[prop]: $scope.amt};  // Set the response
        survey.nextPage();  // Trigger redirect
      }
    }]
  }
}